import { fetchWrapper } from "../utils/fetch-wrapper";

const niveauxService = {
  getAll,
  getById,
  post,
  update,
  delete: _delete,
  count,
};

function getAll(env_client_id: any = "") {
  const queryParams: Record<string, any> = {};

  if (env_client_id !== "") {
    queryParams.env_client_id = env_client_id;
  }
  const queryString = Object.keys(queryParams)
    .map((key) => `${key}=${queryParams[key]}`)
    .join("&");
  return fetchWrapper.get(`niveaux/?${queryString}`);
}

function getById(id) {
  return fetchWrapper.get(`niveaux/${id}`);
}

function post(data) {
  return fetchWrapper.post("niveaux/", data);
}

function update(id, params) {
  return fetchWrapper.put(`niveaux/${id}`, params);
}

function _delete(id) {
  return fetchWrapper.delete(`niveaux/${id}`);
}
function count() {
  return fetchWrapper.get(`niveaux/count`);
}

export default niveauxService;
